import { FC } from 'react';
import { InputProps } from './interface';

const Message: FC<InputProps> = ({ errors, register, asterisk }) => {
  return (
    <>
      <textarea
        placeholder="text"
        className={`block px-3 py-2 peer w-full border border-gray-300 text-[13px] h-[50px] text-[#231f20] placeholder-transparent focus:outline-none rounded ${
          errors?.query && 'border-red-500 focus-visible:border-red-500'
        }`}
        {...register('query')}
        rows={1}
      />
      {errors.query ? (
        <label
          className={`capitalize absolute left-2 -top-[9px] text-red-500 text-xs leadin-[18px] transition-all peer-placeholder-shown:text-xs peer-placeholder-shown:leading-[18px]  peer-placeholder-shown:text-red-500 peer-placeholder-shown:-top-[9px] peer-focus:-top-[9px] peer-focus:text-red-500 peer-focus:text-xs pointer-events-none peer-focus:px-1 bg-white px-1 peer-focus:leading-[18px]`}
        >
          Message{asterisk && '*'}
        </label>
      ) : (
        <label
          className={`capitalize absolute left-2 -top-[9px] text-[#777777] text-xs leading-[18px] transition-all peer-placeholder-shown:text-[13px] peer-placeholder-shown:leading-5 peer-placeholder-shown:text-[#777777] peer-placeholder-shown:top-[10px] peer-focus:-top-[9px] peer-focus:text-[#777777] peer-focus:text-xs peer-focus:leading-[18px] pointer-events-none peer-focus:px-1 bg-white px-1`}
        >
          Message{asterisk && '*'}
        </label>
      )}
    </>
  );
};

export default Message;
